export class VesselAccesses {
    static WITHOUT_VESSEL = 'without_vessel'
    static FOREIGN_VESSEL_ABROAD = 'foreign_vessel_abroad'
    static RF_VESSEL_ABROAD = 'rf_vessel_abroad'
    static RF_VESSEL_SUPPORT = 'rt_vessel_support'
    static ANY_VESSEL = 'any_vessel'
}
